var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Basic = require("../../../elements/Basic");

var _FormationBenchItem = _interopRequireDefault(require("./FormationBenchItem"));

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Formation/FormationBench.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var FormationBench = function (_React$Component) {
  (0, _inherits2.default)(FormationBench, _React$Component);

  var _super = _createSuper(FormationBench);

  function FormationBench() {
    (0, _classCallCheck2.default)(this, FormationBench);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(FormationBench, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          benchHome = _this$props.benchHome,
          benchAway = _this$props.benchAway,
          hideTitle = _this$props.hideTitle,
          onPress = _this$props.onPress,
          createPlayerHref = _this$props.createPlayerHref,
          benchStyle = _this$props.benchStyle,
          NavWrapper = _this$props.NavWrapper;
      if (!benchHome && !benchAway) return null;
      return _react.default.createElement(_Basic.Column, {
        mb: 2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33,
          columnNumber: 13
        }
      }, !hideTitle ? _react.default.createElement(_Basic.View, {
        flexing: true,
        center: true,
        m: 2,
        style: (0, _get.default)(benchStyle, 'titleContainerStyle'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35,
          columnNumber: 21
        }
      }, _react.default.createElement(_Basic.Text, (0, _extends2.default)({
        bold: true
      }, (0, _get.default)(benchStyle, 'titleTextStyle'), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 25
        }
      }), (0, _i18n.default)('formation_bench'))) : null, _react.default.createElement(_Basic.Row, {
        alignItems: "flex-start",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41,
          columnNumber: 17
        }
      }, benchHome ? _react.default.createElement(_Basic.Column, {
        flexing: true,
        mr: 1,
        wrapContent: true,
        style: {
          fontSize: 'medium'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43,
          columnNumber: 25
        }
      }, benchHome.map(function (playerRow, index) {
        return _react.default.createElement(_FormationBenchItem.default, {
          key: "bench_home_" + (0, _get.default)(playerRow, 'lastName') + "_" + (0, _get.default)(playerRow, 'jerseyNumber'),
          even: index % 2 === 0,
          onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onPress, playerRow),
          href: (0, _PropsHelper.executeFunctionOrUndefined)(createPlayerHref, playerRow),
          player: playerRow,
          itemStyle: (0, _get.default)(benchStyle, 'itemStyle'),
          NavWrapper: NavWrapper,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 45,
            columnNumber: 33
          }
        });
      })) : null, benchAway ? _react.default.createElement(_Basic.Column, {
        flexing: true,
        ml: 1,
        wrapContent: true,
        style: {
          fontSize: 'medium'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 61,
          columnNumber: 25
        }
      }, benchAway.map(function (playerRow, index) {
        return _react.default.createElement(_FormationBenchItem.default, {
          key: "bench_away_" + (0, _get.default)(playerRow, 'lastName') + "_" + (0, _get.default)(playerRow, 'jerseyNumber'),
          even: index % 2 === 0,
          onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onPress, playerRow),
          href: (0, _PropsHelper.executeFunctionOrUndefined)(createPlayerHref, playerRow),
          player: playerRow,
          away: true,
          itemStyle: (0, _get.default)(benchStyle, 'itemStyle'),
          NavWrapper: NavWrapper,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 63,
            columnNumber: 33
          }
        });
      })) : null));
    }
  }]);
  return FormationBench;
}(_react.default.Component);

FormationBench.propTypes = {
  benchHome: _propTypes.default.instanceOf(Array),
  benchAway: _propTypes.default.instanceOf(Array),
  onPress: _propTypes.default.func,
  hideTitle: _propTypes.default.bool,
  NavWrapper: _propTypes.default.func
};
var _default = FormationBench;
exports.default = _default;